// eslint-disable-next-line no-nested-ternary
export const isLhb = (pitcher, batter) => (pitcher && batter ? (batter ? batter.Bats === 2 || (batter.Bats === 3 && pitcher.Throws === 1) : false) : false);

export default isLhb;
